// test2422
(2422 && 0);
